import { render, staticRenderFns } from "./searchHolderDependent.vue?vue&type=template&id=4c75316c&"
import script from "./searchHolderDependent.vue?vue&type=script&lang=js&"
export * from "./searchHolderDependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports